export default {"src":"/_next/static/media/fr.e3b26065.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};